import { TransactionStageType } from '@client/graphql/__generated__/types';
import { Hourglass, LucideIcon, PenTool, Send, UserCircle } from 'lucide-react';

export interface PipelineColumnConfig {
  eventType: TransactionStageType;
  label: string;
  icon: LucideIcon;
}

export const PIPELINE_COLUMNS: PipelineColumnConfig[] = [
  {
    eventType: TransactionStageType.SIGNED_AGENCY_AGREEMENT,
    label: 'Agency Agreement Signed',
    icon: UserCircle,
  },
  {
    eventType: TransactionStageType.SUBMITTED_OFFER,
    label: 'Offer Submitted',
    icon: Send,
  },
  {
    eventType: TransactionStageType.UNDER_CONTRACT,
    label: 'Under Contract',
    icon: Hourglass,
  },
  {
    eventType: TransactionStageType.CLOSED,
    label: 'Closed',
    icon: PenTool,
  },
];
